import { client } from "api";
import { TimeEntry } from "models/TimeEntry";

export type GetAllTimeEntriesRequest = void;

export type GetAllTimeEntriesResponse = TimeEntry[];

export const getAllTimeEntries = (): Promise<GetAllTimeEntriesResponse> =>
  client.get<GetAllTimeEntriesResponse>("/absence/all").then((res) => res.data);
